import React from "react";
import HeadTittle from "../../../../components/HeadTittle";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import { EditIcon } from "../../../../components/buttons/IconButtons";
import { permissionObj } from "../../../../Helpers/permission";
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import { STEPS_UPDATE_FOODIE_SHIFT } from "./Model/Models";
import { UpdateShiftApp } from "./Functionality/UpdateShiftApp";
import SectionDiners from "./SubComponents/Steps/SectionDiners";
import SectionDepartments from "./SubComponents/Steps/SectionDepartments";
import SectionCustomAccess from "./SubComponents/Steps/SectionCustomAccess";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Update foodie shift flow. Shows the three sections; a single header action
 * resubmits the whole shift body. Mirrors the attendance EditShiftAccess.
 */
const UpdateShift = () => {

    const {
        id,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        cafeterias, setCafeterias,
        selectDeleteCafeterias, setSelectDeleteCafeterias,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,

        user, setUser,
        selectDeleteUser, setSelectDeleteUser,

        steps,
        activeStep, setActiveStep,
        searchElement, setSearchElement,
        modified, setModified,
        handleStepChange,
        handleAddEdit,
        handleOnBack,
    } = UpdateShiftApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'update'}>
                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_UPDATE)) &&
                    <div className='col-12 d-flex justify-content-end gap-2 flex-wrap mb-4'>
                        <ButtonAction
                            id={'btn_es_update_data'}
                            name='update'
                            className='btn-icon-edit'
                            Icon={EditIcon}
                            onClick={() => handleAddEdit()}
                        />
                    </div>
                }
            </HeadTittle>

            <StepperTabs
                id={id}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_UPDATE_FOODIE_SHIFT.DINERS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_FOODIE_SHIFT.DINERS.INDEX && (
                        <SectionDiners
                            id={id}
                            item={item}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            disabled={disabled}
                            cafeterias={cafeterias}
                            setCafeterias={setCafeterias}
                            selectDeleteCafeterias={selectDeleteCafeterias}
                            setSelectDeleteCafeterias={setSelectDeleteCafeterias}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200'}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_FOODIE_SHIFT.DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_FOODIE_SHIFT.DEPARTMENTS.INDEX && (
                        <SectionDepartments
                            id={id}
                            departments={departments}
                            setDepartments={setDepartments}
                            selectDeleteDepartments={selectDeleteDepartments}
                            setSelectDeleteDepartments={setSelectDeleteDepartments}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200'}
                        />
                    )}
                </StepTab>

                <StepTab index={STEPS_UPDATE_FOODIE_SHIFT.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_FOODIE_SHIFT.CUSTOM_ACCESS.INDEX && (
                        <SectionCustomAccess
                            id={id}
                            user={user}
                            setUser={setUser}
                            selectDeleteUser={selectDeleteUser}
                            setSelectDeleteUser={setSelectDeleteUser}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            mainContainerClass={'border-full-shades-200'}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default UpdateShift
